import { pageTypes, setRank } from './actions';
import { rankLabels } from '@src/utils/constants/rankLabels';
import dashboardDefaultStates from '@src/utils/constants/dashboardDefaultStates';

const initialState = {
	player: null,
	publicLastMatchSource: null,
	publicMatchHistory: [],

	side: 'All',
	role: null,
	diagramRatings: {
		isLoading: true,
		metrics: dashboardDefaultStates.diagram,
		cards: dashboardDefaultStates.diagram,
		rankStats: null,
		role: null,
		progressMetrics: dashboardDefaultStates.progressCards,
	},
	rank: {
		current: null,
		labels: rankLabels,
	},
	ratings: {
		isLoading: false,
		ratings: null,
		metrics: dashboardDefaultStates.ratings,
	},
	aimRatings: {
		isLoading: false,
		ratings: null,
		metrics: dashboardDefaultStates.aimRatings,
		rankDistribution: null,
	},
	aimSide: 'All',
	aimRole: null,
	aimRankStats: null,
	utilitySide: 'All',
	utilityRole: null,
	utilityRankStats: null,
	lastMatch: null,
	rankStats: null,
	playersRankStats: null,
	cardsStats: {
		isLoading: false,
		metrics: [],
		ratings: [],
	},
	rankStatsV2: null,
	clips: null,
	rankToRatings: null,
};

const handlers = {
	[pageTypes.SET_PLAYER]: (state, { payload }) => ({ ...state, player: payload }),
	[pageTypes.SET_PUBLIC_LAST_MATCH_SOURCE]: (state, { payload }) => ({ ...state, publicLastMatchSource: payload }),
	[pageTypes.SET_PUBLIC_MATCH_HISTORY]: (state, { payload }) => ({ ...state, publicMatchHistory: payload }),
	[pageTypes.SET_RANK]: (state, { payload }) => ({ ...state, rank: { ...state.rank, current: payload } }),
	[pageTypes.SET_DIAGRAM_RATINGS]: (state, { payload }) => ({ ...state, diagramRatings: payload }),
	[pageTypes.SET_ROLE]: (state, { payload }) => ({ ...state, role: payload }),
	[pageTypes.SET_RATINGS]: (state, { payload }) => ({ ...state, ratings: payload }),
	[pageTypes.SET_AIM_RATINGS]: (state, { payload }) => ({ ...state, aimRatings: payload }),
	[pageTypes.SET_AIM_ROLE]: (state, { payload }) => ({ ...state, aimRole: payload }),
	[pageTypes.SET_AIM_RANK_STATS]: (state, { payload }) => ({ ...state, aimRankStats: payload }),
	[pageTypes.SET_UTILITY_RATINGS]: (state, { payload }) => ({ ...state, utilityRatings: payload }),
	[pageTypes.SET_UTILITY_ROLE]: (state, { payload }) => ({ ...state, utilityRole: payload }),
	[pageTypes.SET_UTILITY_RANK_STATS]: (state, { payload }) => ({ ...state, utilityRankStats: payload }),
	[pageTypes.SET_RANK_TO_RATINGS]: (state, { payload }) => ({ ...state, rankToRatings: payload }),
	[pageTypes.SET_DIAGRAM_RANK_STATS]: (state, { payload }) => ({
		...state,
		diagramRatings: { ...state.diagramRatings, rankStats: payload },
	}),
	[pageTypes.SET_LAST_MATCH_INFO]: (state, { payload }) => ({ ...state, lastMatch: payload }),
	[pageTypes.SET_RANK_STATS]: (state, { payload }) => ({
		...state,
		rankStats: { ...state.rankStats, [payload.linkType]: payload.data },
	}),
	[pageTypes.SET_PLAYERS_RANK_STATS]: (state, { payload }) => ({ ...state, playersRankStats: payload }),
	[pageTypes.SET_CARDS_STATS]: (state, { payload }) => ({ ...state, cardsStats: payload }),
	[pageTypes.SET_RANK_STATS_V2]: (state, { payload }) => ({ ...state, rankStatsV2: payload }),
	[pageTypes.SET_PLAYER_CLIPS]: (state, { payload }) => ({ ...state, clips: { ...state.clips, clipsList: payload } }),
	[pageTypes.SET_PLAYER_PLACEHOLDER_CLIPS]: (state, { payload }) => ({
		...state,
		clips: { ...state.clips, placeholdersList: payload },
	}),

	DEFAULT: (state) => state,
};

const pageReducer = (state = initialState, action) => {
	const handle = handlers[action.type] || handlers.DEFAULT;
	return handle(state, action);
};

export default pageReducer;
